import { SUBSCRIPTION_ACTION_TYPES } from '../reducers/subscriptionReducer';
import * as subscriptionService from '../../services/subscriptionService';

export const clearSubscription = () => ({
  type: SUBSCRIPTION_ACTION_TYPES.CLEAR,
});

const applyServerState = (dispatch, data) => {
  dispatch({
    type: SUBSCRIPTION_ACTION_TYPES.SET_STATE,
    payload: {
      subscription: data.subscription,
      access: data.access,
      plans: data.plans,
      trialDays: data.trialDays,
    },
  });
  return data;
};

/**
 * PostgreSQL is the source of truth; this pulls it into Redux, which is only a
 * cache. Called after login and after any billing change.
 */
export const syncSubscriptionState = () => async (dispatch) => {
  dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    return applyServerState(dispatch, await subscriptionService.fetchSubscription());
  } catch (e) {
    // A signed-out user has nothing to read; that is not an error worth
    // surfacing, it just means no access yet.
    if (e.status === 401) {
      dispatch({ type: SUBSCRIPTION_ACTION_TYPES.CLEAR });
      return null;
    }
    dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

export const activateTrial = () => async (dispatch) => {
  dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    return applyServerState(dispatch, await subscriptionService.startTrial());
  } catch (e) {
    dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

/** Opens Razorpay Checkout; the resulting state is whatever the server confirms. */
export const subscribeToPlan = (planCode, billing) => async (dispatch, getState) => {
  dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    const { auth } = getState();
    const data = await subscriptionService.subscribeToPlan(planCode, auth && auth.user, billing);
    return applyServerState(dispatch, data);
  } catch (e) {
    dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

export const cancelSubscription = () => async (dispatch) => {
  dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    return applyServerState(dispatch, await subscriptionService.cancelSubscription());
  } catch (e) {
    dispatch({ type: SUBSCRIPTION_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};
